/**
 * @file ScopeContext.jsx
 * @description Context for managing scope selection across components
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2025, NetCyberOps LLC
 */

import React, {createContext, useCallback, useState, useContext} from "react";

const DEMO_SCOPE = {
    id: 'demo',
    name: 'Demo',
    type: 'demo',
    path: '',
    pathList: [],
    subgroups: []
}

export const ScopeContext = createContext();

export function ScopeProvider({children}) {
    const [selectedScope, setSelectedScope] = useState(null);
    const [forceDemoScope, setForceDemoScope] = useState(false);
    const [hideScope, setHideScope] = useState(false);
    const [scopes, setScopes] = useState(null);
    const [scopesLoading, setScopesLoading] = useState(false);
    const [scopesRefreshKey, setScopesRefreshKey] = useState(0);

    const refreshScopes = useCallback(() => setScopesRefreshKey(key => key + 1), []);

    return (
        <ScopeContext.Provider
            value={{
                DEMO_SCOPE,
                selectedScope,
                setSelectedScope,
                forceDemoScope,
                setForceDemoScope,
                hideScope,
                setHideScope,
                scopes,
                setScopes,
                scopesLoading,
                setScopesLoading,
                scopesRefreshKey,
                refreshScopes
            }}
        >
            {children}
        </ScopeContext.Provider>
    );
}

export function useScope() {
    return useContext(ScopeContext);
}